import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

/**
 * Enables drag-to-reorder for file rows within multi-file tiered-list-node
 * fields. On reorder, rewrites each row's hidden `position` input to match
 * the new DOM order so the next form submit persists the ordering.
 */
export class TieredListFileFieldsController extends Controller {
  static targets = ["list"];

  connect() {
    this.sortables = [];
    this.listTargets.forEach((list) => {
      this.sortables.push(
        Sortable.create(list, {
          animation: 150,
          handle: "[data-drag-handle='file']",
          draggable: ".tiered-list-file-field__row",
          ghostClass: "sortable-ghost",
          chosenClass: "sortable-chosen",
          dragClass: "sortable-drag",
          onEnd: () => this.renumber(list),
        })
      );
    });
  }

  disconnect() {
    this.sortables.forEach((s) => s.destroy());
    this.sortables = [];
  }

  renumber(list) {
    const rows = list.querySelectorAll(".tiered-list-file-field__row");
    rows.forEach((row, index) => {
      const positionInput = row.querySelector(
        "input[name*='[position]']"
      );
      if (positionInput) positionInput.value = String(index + 1);
    });
  }
}
